var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg360(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20L8.4 17.9L11.025 15.2C7.825 14.775 5.1875 13.9 3.1125 12.575C1.0375 11.25 0 9.725 0 8C0 5.925 1.44375 4.15625 4.33125 2.69375C7.21875 1.23125 10.775 0.5 15 0.5C19.225 0.5 22.7813 1.23125 25.6688 2.69375C28.5563 4.15625 30 5.925 30 8C30 9.55 29.1687 10.9375 27.5062 12.1625C25.8438 13.3875 23.675 14.3 21 14.9V11.825C22.925 11.325 24.4062 10.7063 25.4437 9.96875C26.4812 9.23125 27 8.575 27 8C27 7.2 25.9312 6.25 23.7938 5.15C21.6562 4.05 18.725 3.5 15 3.5C11.275 3.5 8.34375 4.05 6.20625 5.15C4.06875 6.25 3 7.2 3 8C3 8.6 3.6375 9.31875 4.9125 10.1562C6.1875 10.9937 8 11.625 10.35 12.05L8.4 10.1L10.5 8L16.5 14L10.5 20Z",
    fill: "#004EA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg360);
export default __webpack_public_path__ + "static/media/360.5509d56fe0a6bc5417f78d8cbbe7ba24.svg";
export { ForwardRef as ReactComponent };